/**
 * Обновляет title и meta description в DOM (для SPA без SSR).
 * Поисковики с рендерингом JS (Google) обычно подхватывают значения после выполнения бандла.
 */
export function setSeoMeta({ title, description }) {
  if (title != null) {
    document.title = title;
  }
  if (description != null) {
    let el = document.querySelector('meta[name="description"]');
    if (!el) {
      el = document.createElement('meta');
      el.setAttribute('name', 'description');
      document.head.appendChild(el);
    }
    el.setAttribute('content', description);
  }
}
